module.exports = {
	"id": "IR",
	"name": "Iran",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.0111,
			"5": 0.0111,
			"6": 0.0111,
			"7": 0.00555,
			"8": 0.01665,
			"9": null,
			"10": 0.0111,
			"11": 0.0777,
			"12": 0.0111,
			"13": 0.0111,
			"14": 0.02775,
			"15": 0.01665,
			"16": 0.00555,
			"17": 0.0111,
			"18": 0.01665,
			"19": 0.0111,
			"20": 0.02775,
			"21": 0.0111,
			"22": 0.0444,
			"23": 0.0333,
			"24": 0.0222,
			"25": 0.01665,
			"26": 0.0222,
			"27": 0.01665,
			"28": 0.0222,
			"29": 0.03885,
			"30": 0.0222,
			"31": 0.0555,
			"32": 0.0222,
			"33": 0.0444,
			"34": 0.02775,
			"35": 0.02775,
			"36": 0.0333,
			"37": 0.02775,
			"38": 0.0999,
			"39": 0.0555,
			"40": 0.03885,
			"41": 0.0333,
			"42": 0.02775,
			"43": 0.13875,
			"44": 0.06105,
			"45": 0.07215,
			"46": 0.08325,
			"47": 0.0888,
			"48": 0.10545,
			"49": 1.0212,
			"50": 0.12765,
			"51": 0.5106,
			"52": 0.4107,
			"53": 14.2635,
			"54": 3.85725,
			"55": 0.0555,
			"56": 0.01665,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.0333,
			"4": 0.0444,
			"5": 0.0111,
			"6": 0.0111,
			"7": 0.01665,
			"8": 0.01665,
			"9": 0.01665,
			"10": 0.01665,
			"11": 0.0333,
			"12": 0.0888,
			"13": 0.0333,
			"14": 0.0333,
			"15": 0.0333,
			"16": 0.03885,
			"17": 0.0222,
			"18": 0.0222,
			"19": 0.0111,
			"20": 0.0222,
			"21": 0.0333,
			"22": 0.02775,
			"23": 0.02775,
			"24": 0.04995,
			"25": 0.0444,
			"26": 0.0333,
			"27": 0.02775,
			"28": 0.0222,
			"29": 0.0666,
			"30": 0.07215,
			"31": 0.0666,
			"32": 0.0555,
			"33": 0.10545,
			"34": 0.0666,
			"35": 0.0888,
			"36": 0.0666,
			"37": 0.0777,
			"38": 0.1332,
			"39": 0.11655,
			"40": 0.111,
			"41": 0.1665,
			"42": 0.14985,
			"43": 0.74925,
			"44": 0.2886,
			"45": 0.31635,
			"46": 0.27195,
			"47": 1.87035,
			"48": 1.41525,
			"49": 10.8558,
			"50": 0.86025,
			"51": 0.01665,
			"52": null,
			"3.5": 0.01665,
			"3.6": 0.06105
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.0111,
			"15": null,
			"16": 0.0111,
			"17": 0.00555,
			"18": null,
			"19": null,
			"20": 0.00555,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.00555,
			"26": 0.00555,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.00555,
			"31": null,
			"32": 0.0111,
			"33": null,
			"34": 0.0111,
			"35": 0.00555,
			"36": 0.03885,
			"37": 0.01665,
			"38": 0.0888,
			"39": 0.12765,
			"40": 0.1998,
			"41": 0.02775,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.0111,
			"11.6": 0.0111,
			"12.1": 0.0444
		},
		"safari": {
			"0": null,
			"4": 0.0111,
			"5": 0.00555,
			"6": null,
			"7": 0.00555,
			"8": 0.0444,
			"9": 0.0555,
			"10": 0.19425,
			"3.1": null,
			"3.2": null,
			"5.1": 0.0111,
			"6.1": null,
			"7.1": null,
			"9.1": 0.13875
		},
		"ios_saf": {
			"8": 0,
			"10": 2.53703355537,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0683701186511,
			"8.1-8.4": 0.126310897169,
			"9.0-9.2": 0.0602584096586,
			"9.3": 0.919327019151
		},
		"android": {
			"3": 0,
			"4": 0.125807364341,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0157259205426,
			"4.1": 0.453805135659,
			"4.2-4.3": 1.13451283915,
			"4.4": 2.60151656977,
			"4.4.3-4.4.4": 2.62398217054
		},
		"ie": {
			"6": 0.649280520781,
			"7": 0.772419929895,
			"8": 3.62701532298,
			"9": 1.12504641963,
			"10": 0.878767601402,
			"11": 4.12517020531,
			"5.5": null
		},
		"op_mob": {
			"0": 0.277729813018,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00771471702828
		},
		"edge": {
			"12": 0.1776,
			"13": 0.20535,
			"14": 0.2442
		},
		"ie_mob": {
			"10": 0.0184267605634,
			"11": 0.0750232394366
		},
		"bb": {
			"7": 0.0144625,
			"10": null
		},
		"samsung": {
			"0": 7.62285
		},
		"and_uc": {
			"0": 1.6376
		},
		"op_mini": {
			"0": 3.74180546995
		},
		"and_chr": {
			"0": 21.20335
		},
		"and_ff": {
			"0": 0.2403
		}
	},
	"total": 99.0967125
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/IR.json
 ** module id = 553
 ** module chunks = 0
 **/